import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query standart sozlamalari.
 *
 * ⚠️ `retry` bu yerda xsib-selfcare'dan FARQLI — bu ilova ishonchsiz mobil
 * tarmoqda ishlaydi (mehmon Wi-Fi'ga endi ulanmoqda), ya'ni birinchi so'rov
 * tez-tez vaqtincha muvaffaqiyatsiz bo'lishi kutiladi. Shuning uchun GET
 * so'rovlar (zona ma'lumoti) uchun engil qayta urinish qoldirilgan, lekin
 * MUTATSIYALAR (OTP so'rash, kirish berish) hech qachon avtomatik qayta
 * urinilmaydi: ular pul sarflashi (SMS) yoki ikkilanadigan yon ta'sirga ega
 * bo'lishi mumkin — foydalanuvchi ANIQ tugmani qayta bosishi kerak, vazifa
 * hujjatining "qayta urinish tugmasini ber" talabi shundan.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } }).response?.status
        if (typeof status === 'number' && status >= 400 && status < 500) return false
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})
